import(/* webpackMode: "eager" */ "/vercel/path0/app/json-formatter/page.tsx");
